import { ActivityProfile } from '../../components/system-logs/activity';

export default function ActivityProfilePage() {
  return <ActivityProfile />;
}
